<template>
  <router-view/>
</template>

<style lang="less">
html, body, #app {
  margin: 0;
}
</style>
